/** SIWS message creation is async already, so its onchain module can be lazy. */
export async function genSolanaMessage(address, nonce) {
    const implementation = await import("./solana-message");
    return implementation.genSolanaMessage(address, nonce);
}
